<template>
  <div>
    <div v-if="!loaded_compliance_terms" class="row">
      <div class="col-12">
        <order_loader :loadingMessage="'Compliance & Terms'"></order_loader>
      </div>
    </div>
    <div v-else>
      <div v-if="$store.state.orders.order_steps.timesheet_authorisation.partial_order_complete">
      <ValidationObserver ref="orderComplianceTermsForm" slim>
        <form role="form" @submit.prevent="order_compliance_terms_submit">

          <div class="row">
            <!-- Direct Recruit / Comparable Employee -->
            <div v-if="$store.state.orders.order_steps.basic_info.data.type === 'Temporary (PAYE)'" class="col-12">
              <b-card header="Direct Recruit / Comparable Employee" header-tag="h4" body-class="mb-3 pb-2 pt-5">
                <div class="row">
                  <div class="col-12">
                    <p>Regulation 5 of the Agency Workers Regulations provides that an Agency Worker who completes a 12 week Qualifying Period in the same role for you will be
                      entitled to receive treatment equal to what they would have received had you recruited them directly.</p>

                    <p>Please complete the details below for the agency to understand what terms and conditions either the Agency Worker or a comparable employee would receive and
                      to which the Agency Worker will be entitled when s/he completes the Qualifying Period. The agency must be immediately informed if any of the information
                      changes, including if the comparable employee leaves.</p>
                  </div>

                  <div class="col-12" id="drce_positions">
                    <div class="row drce_position" v-for="p in parseInt(positions.number_of_positions)">
                      <div class="col-12">
                        <h5 class="bp_color">{{ positions.position[p].job_title }}</h5>
                      </div>

                      <label class="col-md-8" :for="'drce_is_required_' + p">
                        Does the Job Title and/or Job Duties exist already within the company? <strong class="font-italic">And</strong> Does the temp role within this order also
                        have the potential to last 12 weeks or longer?</label>
                      <div class="col-md-4">
                        <bootstrap-toggle v-model="compliance_terms.drce[p].is_required" :name="'drce_is_required_' + p" :id="'drce_is_required_' + p"
                                          :options="{ on: 'Yes', off: 'No' }" @input="toggle_drce(compliance_terms.drce[p].is_required, p)"/>
                      </div>

                      <div v-if="compliance_terms.drce[p].is_required" class="col-12 mt-2">
                        <div class="row">
                          <!-- Basic Salary (£) -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required|decimal" v-slot="{errors, classes}" :name="'Basic Salary (£) ' + p" tag="div">
                              <label class="form-label" :for="'drce_basic_salary_' + p">Basic Salary (&pound;)</label>
                              <input type="text" v-model="compliance_terms.drce[p].basic_salary" :id="'drce_basic_salary_' + p" :name="'drce_basic_salary_' + p"
                                     class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Basic Hours -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Basic Hours ' + p" tag="div">
                              <label class="form-label" :for="'drce_basic_hours_' + p">Basic Hours</label>
                              <input type="text" v-model="compliance_terms.drce[p].basic_hours" :id="'drce_basic_hours_' + p" :name="'drce_basic_hours_' + p"
                                     class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Rest Periods -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Rest Periods ' + p" tag="div">
                              <label class="form-label" :for="'drce_rest_periods_' + p">Rest Periods</label>
                              <input type="text" v-model="compliance_terms.drce[p].rest_periods" :id="'drce_rest_periods_' + p" :name="'drce_rest_periods_' + p"
                                     class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Lunch Break -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Lunch Break ' + p" tag="div">
                              <label class="form-label" :for="'drce_lunch_break_' + p">Lunch Break</label>
                              <input type="text" v-model="compliance_terms.drce[p].lunch_break" :id="'drce_lunch_break_' + p" :name="'drce_lunch_break_' + p"
                                     class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Overtime Payments -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Overtime Payments ' + p" tag="div">
                              <label class="form-label" :for="'drce_overtime_payments_' + p">Overtime Payments</label>
                              <input type="text" v-model="compliance_terms.drce[p].overtime_payments" :id="'drce_overtime_payments_' + p" :name="'drce_overtime_payments_' + p"
                                     class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Shift Allowance -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Shift Allowance ' + p" tag="div">
                              <label class="form-label" :for="'drce_shift_allowance_' + p">Shift Allowance</label>
                              <input type="text" v-model="compliance_terms.drce[p].shift_allowance" :id="'drce_shift_allowance_' + p" :name="'drce_shift_allowance_' + p"
                                     class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Commission -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Commission ' + p" tag="div">
                              <label class="form-label" :for="'drce_commission_' + p">Commission</label>
                              <input type="text" v-model="compliance_terms.drce[p].commission" :id="'drce_commission_' + p" :name="'drce_commission_' + p"
                                     class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Annual Leave Entitlement -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Annual Leave Entitlement ' + p" tag="div">
                              <label class="form-label" :for="'drce_annual_leave_entitlement_' + p">Annual Leave Entitlement</label>
                              <input type="text" v-model="compliance_terms.drce[p].annual_leave_entitlement" :id="'drce_annual_leave_entitlement_' + p"
                                     :name="'drce_annual_leave_entitlement_' + p" class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Monetary Benefits -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Monetary Benefits ' + p" tag="div">
                              <label class="form-label" :for="'drce_monetary_benefits_' + p">Monetary Benefits</label>
                              <input type="text" v-model="compliance_terms.drce[p].monetary_benefits" :id="'drce_monetary_benefits_' + p" :name="'drce_monetary_benefits_' + p"
                                     class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Pension Contribution -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Pension Contribution ' + p" tag="div">
                              <label class="form-label" :for="'drce_pension_contribution_' + p">Pension Contribution</label>
                              <input type="text" v-model="compliance_terms.drce[p].pension_contribution" :id="'drce_pension_contribution_' + p"
                                     :name="'drce_pension_contribution_' + p" class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Facilities -->
                          <div class="col-xl-3 form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Facilities ' + p" tag="div">
                              <label class="form-label" :for="'drce_facilities_' + p">Facilities</label>
                              <input type="text" v-model="compliance_terms.drce[p].facilities" :id="'drce_facilities_' + p" :name="'drce_facilities_' + p"
                                     class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 horizontal_line">
                        <hr>
                      </div>
                    </div>

                  </div>
                </div>
              </b-card>
            </div>
            <!-- Mutuality of Obligation -->
            <div v-if="$store.state.orders.order_steps.basic_info.data.type === 'Contract'" class="col-12">
              <b-card header="Mutuality of Obligation" header-tag="h4" body-class="mb-3 pb-2 pt-5">
                <div class="row">
                  <div class="col-12">
                    <p><strong>Mutuality of obligation refers to the employer’s obligation to give work and the employee’s obligation to complete it.</strong><br>
                      It's one of the key tests that tax investigations and employment tribunals will use to determine a contractor’s employment status (and whether they owe any
                      tax).<br>
                      If an element of mutuality of obligation exists then HMRC may argue that the relationship between contractor and client resembles employment, placing the
                      contractor inside IR35.</p>
                    <hr>
                  </div>

                  <label class="col-md-8 cardLabel" for="moo_sdc">Is the worker subject to any supervision, direction or control?</label>
                  <div class="col-md-4">
                    <bootstrap-toggle v-model="compliance_terms.moo.sdc" name="moo_sdc" id="moo_sdc" :options="{ on: 'Yes', off: 'No' }"/>
                  </div>

                  <label class="col-md-8 cardLabel" for="moo_worker_decline_job_movement">Can the worker decline the request to be moved from job to job?</label>
                  <div class="col-md-4">
                    <bootstrap-toggle v-model="compliance_terms.moo.worker_decline_job_movement" name="moo_worker_decline_job_movement" id="moo_worker_decline_job_movement"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>

                  <label class="col-md-8 cardLabel" for="moo_end_user_offer_further_work">
                    Once this contract is completed are you (the end user) under any obligation to offer further work?
                  </label>
                  <div class="col-md-4">
                    <bootstrap-toggle v-model="compliance_terms.moo.end_user_offer_further_work" name="moo_end_user_offer_further_work" id="moo_end_user_offer_further_work"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>

                  <label class="col-md-8 cardLabel" for="moo_worker_accept_further_work">
                    Once this contract is completed is the worker under any obligation to accept additional work offered?
                  </label>
                  <div class="col-md-4">
                    <bootstrap-toggle v-model="compliance_terms.moo.worker_accept_further_work" name="moo_worker_accept_further_work" id="moo_worker_accept_further_work"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>

                  <label class="col-md-8 cardLabel" for="moo_how_work_performed">Does the worker have the freedom to choose how the work is to be performed?</label>
                  <div class="col-md-4">
                    <bootstrap-toggle v-model="compliance_terms.moo.how_work_performed" name="moo_how_work_performed" id="moo_how_work_performed"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>

                  <label class="col-md-8 cardLabel" for="moo_responsible_work_standard">Is the worker responsible for the standard of their own work?</label>
                  <div class="col-md-4">
                    <bootstrap-toggle v-model="compliance_terms.moo.responsible_work_standard" name="moo_responsible_work_standard" id="moo_responsible_work_standard"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>

                  <label class="col-md-8 cardLabel" for="moo_carry_financial_risk">
                    Does the worker carry financial risk in relation to any work completed? (Especially substandard work)
                  </label>
                  <div class="col-md-4">
                    <bootstrap-toggle v-model="compliance_terms.moo.carry_financial_risk" name="moo_carry_financial_risk" id="moo_carry_financial_risk"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>
                </div>
              </b-card>
            </div>
            <!-- Terms of Business -->
            <div class="col-12">
              <b-card header="Terms of Business" header-tag="h4" body-class="mb-3 pb-2 pt-5">
                <div class="row">
                  <div class="col-12" id="tobs">
                    <div class="row tob" v-for="p in parseInt(positions.number_of_positions)">
                      <div class="col-xl-6 form-group">
                        <h5 class="cardLabel font-weight-bold">{{ positions.position[p].job_title.job_title }}</h5>
                      </div>
                      <div class="col-xl-6 form-group">
                        <ValidationProvider rules="" v-slot="{errors, classes}" :name="'Client Ref/PO ' + p" tag="div">
                          <label class="form-label" :for="'client_ref_po_' + p">Client Ref/PO</label>
                          <input type="text" v-model="compliance_terms.terms_business[p].client_ref_po" :id="'client_ref_po_' + p" :name="'client_ref_po_' + p" class="form-input"
                                 :class="classes">
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                      <div class="col-12 form-group">
                        <ValidationProvider rules="" v-slot="{errors, classes}" :name="'Amendments to Terms ' + p" tag="div">
                          <label class="form-label" :for="'amendments_to_terms_' + p">Amendments to Terms</label>
                          <textarea v-model="compliance_terms.terms_business[p].amendments_to_terms" rows="3" :name="'amendments_to_terms_' + p" class="form-input resize_vertical"
                                    :class="classes" :id="'amendments_to_terms_' + p"></textarea>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                      <div class="col-12 horizontal_line">
                        <hr>
                      </div>
                    </div>
                  </div>

                </div>
              </b-card>
            </div>
            <!-- Authorise Terms of Business -->
            <div class="col-12">
              <b-card header="Authorise Terms of Business" header-tag="h4" body-class="mb-3 pb-2 pt-5">
                <div class="row">
                  <div class="col-6">
                    <h4>Authorise Terms Contact</h4>
                  </div>
                  <div class="col-6">
                    <button @click.prevent="add_contact" class="btn orcaBtn blueBtn sm_btn float-right mb-3">Add client contact</button>
                  </div>
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Authorise Terms Contact" tag="div" class="basic_order_info">
                      <label class="form-label" for="auth_terms_contact">Authorise Terms Contact</label>
                      <multiselect v-model="compliance_terms.auth_terms_contact" placeholder="" id="auth_terms_contact" label="contact_label" track-by="id"
                                   :options="ms_opts.auth_terms_contact" :option-height="200" :custom-label="contact_label" :show-labels="false" class="requiredField"
                                   :class="classes">
                        <template slot="singleLabel" slot-scope="props">
                        <span class="option__desc_single">
                          <span class="option__title">{{ props.option.person.first_name }} {{ props.option.person.surname }}</span>
                        </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.person.first_name }} {{ props.option.person.surname }}</span>
                            <span class="option__small" v-if="props.option.rel_profile.job_title_id !== null">{{ props.option.rel_profile.job_title.job_title }}</span>
                          </div>
                        </template>
                      </multiselect>

                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="auth_terms_contact_job_title">Authorise Terms Contact: Job Title</label>
                    <input v-if="compliance_terms.auth_terms_contact !== null && compliance_terms.auth_terms_contact.rel_profile.job_title_id !== null" type="text"
                           v-model="compliance_terms.auth_terms_contact.rel_profile.job_title.job_title"
                           id="auth_terms_contact_job_title" name="auth_terms_contact_job_title" class="form-input disabled" readonly>
                    <input v-else type="text" id="null_auth_terms_contact_job_title" name="null_auth_terms_contact_job_title" class="form-input disabled" readonly>
                  </div>
                  <div class="col-xl-3 form-group">
                    <ValidationProvider :rules="{ 'required' : isMobileRequired }" v-slot="{errors, classes}" name="Job Contact: Landline Phone" tag="div">
                      <label class="form-label" for="auth_terms_contact_mobile">Authorise Terms Contact: Mobile</label>
                      <input v-if="compliance_terms.auth_terms_contact !== null" type="text" v-model="compliance_terms.auth_terms_contact.phones.work_mobile"
                             id="auth_terms_contact_mobile" name="auth_terms_contact_mobile" class="form-input disabled" :class="classes" readonly>
                      <input v-else type="text" id="null_auth_terms_contact_mobile" name="null_auth_terms_contact_mobile" class="form-input disabled" readonly>
                      <div v-if="errors[0]" class="vvERROR">The Job Contact: Mobile or Landline Phone field is required</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-xl-3 form-group">
                    <ValidationProvider :rules="{ 'required' : isPhoneRequired }" v-slot="{errors, classes}" name="Job Contact: Landline Phone" tag="div">
                      <label class="form-label" for="auth_terms_contact_phone">Authorise Terms Contact: Landline Phone</label>
                      <input v-if="compliance_terms.auth_terms_contact !== null" type="text" v-model="compliance_terms.auth_terms_contact.phones.work_landline"
                             id="auth_terms_contact_phone" name="auth_terms_contact_phone" class="form-input disabled" :class="classes" readonly>
                      <input v-else type="text" id="null_auth_terms_contact_phone" name="null_auth_terms_contact_phone" class="form-input disabled" readonly>
                      <div v-if="errors[0]" class="vvERROR">The Job Contact: Mobile or Landline Phone field is required</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Authorise Terms Contact: Email" tag="div">
                      <label class="form-label" for="auth_terms_contact_email">Authorise Terms Contact: Email</label>
                      <input v-if="compliance_terms.auth_terms_contact !== null" type="text" v-model="compliance_terms.auth_terms_contact.emails.work_email"
                             id="auth_terms_contact_email" :class="classes" name="auth_terms_contact_email" class="form-input disabled" readonly>
                      <input v-else type="text" id="null_auth_terms_contact_email" name="null_auth_terms_contact_email" class="form-input disabled" :class="classes" readonly>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                </div>
              </b-card>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 offset-xl-6">
              <button class="btn orcaBtn w-100" type="submit">Save Compliance & Terms</button>
            </div>
          </div>
        </form>
      </ValidationObserver>
      </div>
      <div v-else class="row">
        <div class="col-12">
          <h5 class="red_color">You must complete all previous sections first before filling out Compliance & Terms information.</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import BootstrapToggle from 'vue-bootstrap-toggle';
import order_loader from "loaders/order_loader";

export default {
  name: "compliance_terms",
  components: {
    Multiselect,
    BootstrapToggle,
    order_loader
  },
  data() {
    return {
      loaded_compliance_terms: false,

      ms_opts: {
        auth_terms_contact: []
      },
      positions: [],

      compliance_terms: {
        moo: {
          sdc: false,
          worker_decline_job_movement: true,
          end_user_offer_further_work: false,
          worker_accept_further_work: false,
          how_work_performed: true,
          responsible_work_standard: true,
          carry_financial_risk: true,
        },
        drce: [{}],
        auth_terms_contact: null,

        terms_business: [{}],
        ltd_reg_number: '12312312',
      }
    }
  },
  beforeMount() {
    this.load_data().then(() => {
      this.loaded_compliance_terms = true
    })
  },
  computed: {
    contact_reload() {
      return this.$store.state.contacts.reload_contacts;
    },
    isPhoneRequired() {
      if (this.compliance_terms.auth_terms_contact !== null) {
        return this.compliance_terms.auth_terms_contact.phones.work_mobile === null;
      }
    },
    isMobileRequired() {
      if (this.compliance_terms.auth_terms_contact !== null) {
        return this.compliance_terms.auth_terms_contact.phones.work_landline === null;
      }
    }
  },
  methods: {
    load_data() {
      return new Promise(resolve => {
        if (this.$store.state.orders.order_steps.basic_info.partial_order_complete) {
          axios.get(this.crmApiPath + 'contact/company/' + this.$store.state.orders.order_steps.basic_info.data.company.id).then(contacts => {
            this.ms_opts.auth_terms_contact = contacts.data
          })
        }

        if (this.$store.state.orders.order_steps.positions_rates.partial_order_complete) {
          this.positions = this.$store.state.orders.order_steps.positions_rates.data;

          for (let i = 1; i < this.positions.position.length; i++) {
            if (this.$store.state.orders.order_steps.basic_info.data.type === 'Temporary (PAYE)') {
              this.compliance_terms.drce.push({
                is_required: false,
                basic_salary: '',
                basic_hours: '',
                rest_periods: '',
                lunch_break: '',
                overtime_payments: '',
                shift_allowance: '',
                commission: '',
                annual_leave_entitlement: '',
                monetary_benefits: '',
                pension_contribution: '',
                facilities: '',
              });
            }
            this.compliance_terms.terms_business.push({
              client_ref_po: '',
              amendments_to_terms: ''
            })
          }
        }

        if (this.$store.state.orders.order_steps.compliance_terms.partial_order_complete) {
          this.compliance_terms = this.$store.state.orders.order_steps.compliance_terms.data;
        }
        resolve();
      });
    },

    // Reset DRCE if toggle value is false
    toggle_drce(val, pos) {
      if (!val) {
        this.compliance_terms.drce[pos].basic_salary = '';
        this.compliance_terms.drce[pos].basic_hours = '';
        this.compliance_terms.drce[pos].rest_periods = '';
        this.compliance_terms.drce[pos].lunch_break = '';
        this.compliance_terms.drce[pos].overtime_payments = '';
        this.compliance_terms.drce[pos].shift_allowance = '';
        this.compliance_terms.drce[pos].commission = '';
        this.compliance_terms.drce[pos].annual_leave_entitlement = '';
        this.compliance_terms.drce[pos].monetary_benefits = '';
        this.compliance_terms.drce[pos].pension_contribution = '';
        this.compliance_terms.drce[pos].facilities = '';
      }
    },

      contact_label({person}) {
          return `${person.first_name} ${person.surname}`;
      },
    // add contact
    add_contact() {
      this.$store.commit('SHOW_ADD_CONTACT_MODAL', {
        company_id: this.$store.state.orders.order_steps.basic_info.data.company.id,
        company_name: this.$store.state.orders.order_steps.basic_info.data.company.company_name
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_contact_modal'));
    },
    // submit
    order_compliance_terms_submit() {
      this.$refs.orderComplianceTermsForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.orderComplianceTermsForm);
          this.$store.commit('SAVE_COMPLIANCE_TERMS_ERRORS', this.compliance_terms);
        }
        else {
          this.$store.commit('SAVE_COMPLIANCE_TERMS_COMPLETED', this.compliance_terms);
        }
      });
    }
  },
  watch: {
    contact_reload(val) {
      if (val) {
        axios.get(this.crmApiPath + 'contact/company/' + this.$store.state.orders.order_steps.basic_info.data.company.id).then(contacts => {
          this.ms_opts.auth_terms_contact = contacts.data
        })
      }
    },
    'compliance_terms.auth_terms_contact'(contact) {
      if (contact !== null) {
        // if contact has no email address or if contact has no phone number and no mobile number
        if (contact.emails.work_email === null || (contact.phones.work_landline === null && contact.phones.work_mobile === null)) {
          this.$store.commit('SHOW_EDIT_CONTACT_MODAL', {
            contact_id: contact.id,
            company_id: contact.company_id,
          });
          this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_contact_modal'))
        }
      }
    },
    'compliance_terms.moo.sdc'(val) {
      if (val) {
        this.$snotify.confirm('', '', {
          closeOnClick: false,
          position: 'centerCenter',
          backdrop: 0.5,
          html: '<div class="snotifyToast__title">Mutuality of Obligation Issue</div>' +
              '<div class="snotifyToast__body">' +
              '<br>The answer you have selected would indicate that the workers filling this order would not be classified as self-employed.<br><br>' +
              '<strong style="font-size: 1rem;">Please Review and Discuss with Client</strong>' +
              '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
              '</div>',
          buttons: [
            {
              text: 'Ok', action: (toast) => {
                this.$snotify.remove(toast.id);
                this.compliance_terms.moo.sdc = false;
              }
            }
          ]
        });
      }
    },
    'compliance_terms.moo.worker_decline_job_movement'(val) {
      if (!val) {
        this.$snotify.confirm('', '', {
          closeOnClick: false,
          position: 'centerCenter',
          backdrop: 0.5,
          html: '<div class="snotifyToast__title">Mutuality of Obligation Issue</div>' +
              '<div class="snotifyToast__body">' +
              '<br>The answer you have selected would indicate that the workers filling this order would not be classified as self-employed.<br><br>' +
              '<strong style="font-size: 1rem;">Please Review and Discuss with Client</strong>' +
              '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
              '</div>',
          buttons: [
            {
              text: 'Ok', action: (toast) => {
                this.$snotify.remove(toast.id);
                this.compliance_terms.moo.worker_decline_job_movement = true;
              }
            }
          ]
        });
      }
    },
    'compliance_terms.moo.end_user_offer_further_work'(val) {
      if (val) {
        this.$snotify.confirm('', '', {
          closeOnClick: false,
          position: 'centerCenter',
          backdrop: 0.5,
          html: '<div class="snotifyToast__title">Mutuality of Obligation Issue</div>' +
              '<div class="snotifyToast__body">' +
              '<br>The answer you have selected would indicate that the workers filling this order would not be classified as self-employed.<br><br>' +
              '<strong style="font-size: 1rem;">Please Review and Discuss with Client</strong>' +
              '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
              '</div>',
          buttons: [
            {
              text: 'Ok', action: (toast) => {
                this.$snotify.remove(toast.id);
                this.compliance_terms.moo.end_user_offer_further_work = false;
              }
            }
          ]
        });
      }
    },
    'compliance_terms.moo.worker_accept_further_work'(val) {
      if (val) {
        this.$snotify.confirm('', '', {
          closeOnClick: false,
          position: 'centerCenter',
          backdrop: 0.5,
          html: '<div class="snotifyToast__title">Mutuality of Obligation Issue</div>' +
              '<div class="snotifyToast__body">' +
              '<br>The answer you have selected would indicate that the workers filling this order would not be classified as self-employed.<br><br>' +
              '<strong style="font-size: 1rem;">Please Review and Discuss with Client</strong>' +
              '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
              '</div>',
          buttons: [
            {
              text: 'Ok', action: (toast) => {
                this.$snotify.remove(toast.id);
                this.compliance_terms.moo.worker_accept_further_work = false;
              }
            }
          ]
        });
      }
    },
    'compliance_terms.moo.how_work_performed'(val) {
      if (!val) {
        this.$snotify.confirm('', '', {
          closeOnClick: false,
          position: 'centerCenter',
          backdrop: 0.5,
          html: '<div class="snotifyToast__title">Mutuality of Obligation Issue</div>' +
              '<div class="snotifyToast__body">' +
              '<br>The answer you have selected would indicate that the workers filling this order would not be classified as self-employed.<br><br>' +
              '<strong style="font-size: 1rem;">Please Review and Discuss with Client</strong>' +
              '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
              '</div>',
          buttons: [
            {
              text: 'Ok', action: (toast) => {
                this.$snotify.remove(toast.id);
                this.compliance_terms.moo.how_work_performed = true;
              }
            }
          ]
        });
      }
    },
    'compliance_terms.moo.responsible_work_standard'(val) {
      if (!val) {
        this.$snotify.confirm('', '', {
          closeOnClick: false,
          position: 'centerCenter',
          backdrop: 0.5,
          html: '<div class="snotifyToast__title">Mutuality of Obligation Issue</div>' +
              '<div class="snotifyToast__body">' +
              '<br>The answer you have selected would indicate that the workers filling this order would not be classified as self-employed.<br><br>' +
              '<strong style="font-size: 1rem;">Please Review and Discuss with Client</strong>' +
              '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
              '</div>',
          buttons: [
            {
              text: 'Ok', action: (toast) => {
                this.$snotify.remove(toast.id);
                this.compliance_terms.moo.responsible_work_standard = true;
              }
            }
          ]
        });
      }
    },
    'compliance_terms.moo.carry_financial_risk'(val) {
      if (!val) {
        this.$snotify.confirm('', '', {
          closeOnClick: false,
          position: 'centerCenter',
          backdrop: 0.5,
          html: '<div class="snotifyToast__title">Mutuality of Obligation Issue</div>' +
              '<div class="snotifyToast__body">' +
              '<br>The answer you have selected would indicate that the workers filling this order would not be classified as self-employed.<br><br>' +
              '<strong style="font-size: 1rem;">Please Review and Discuss with Client</strong>' +
              '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
              '</div>',
          buttons: [
            {
              text: 'Ok', action: (toast) => {
                this.$snotify.remove(toast.id);
                this.compliance_terms.moo.carry_financial_risk = true;
              }
            }
          ]
        });
      }
    },
    'compliance_terms.drce.is_required'(val) {
      if (!val) {
        this.compliance_terms.drce = {
          is_required: false,
          basic_salary: '',
          basic_hours: '',
          rest_periods: '',
          lunch_break: '',
          overtime_payments: '',
          shift_allowance: '',
          commission: '',
          annual_leave_entitlement: '',
          monetary_benefits: '',
          pension_contribution: '',
          facilities: '',
        };
      }
    }
  }
}
</script>

<style scoped lang="scss">
#drce_positions {
  .drce_position {
    &:last-of-type {
      .horizontal_line {
        display: none;
      }
    }
  }
}

#tobs {
  .tob {
    &:last-of-type {
      .horizontal_line {
        display: none;
      }
    }
  }
}
</style>
<style lang="scss">
.basic_order_info {
  .multiselect__option {
    height: auto !important;
  }

  .option__desc {
    .option__title {
      font-weight: bold;
      display:     block;
    }

    .option__small {
      font-size: 0.7rem;
      display:   block;
    }
  }
}
</style>
